// frontend/src/components/MapControls.jsx

import React, { useCallback } from 'react';
import { Eye, EyeOff, RefreshCw, Target } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

// Memoize the component to prevent unnecessary re-renders
const MapControls = React.memo(({ 
    mapRef, 
    showTooltips, 
    onToggleTooltips, 
    onForceRefresh, 
    isDriver,       
    t 
}) => {
    const { cn, components } = useTheme();
    
    // CRITICAL FIX: Use useCallback for the handler functions
    const handleCenterMap = useCallback(() => {
        console.log('Center button clicked, mapRef:', mapRef);
        if (mapRef?.current?.centerMap) {
            mapRef.current.centerMap(); 
        } else {
            console.error('centerMap function not available');
        }
    }, [mapRef]);
    
    const handleToggleTooltips = useCallback(() => {
        
        onToggleTooltips(!showTooltips);
    }, [onToggleTooltips, showTooltips]);

    return (
        <div className="absolute left-3 top-24 z-[1000]">
            <div className="flex flex-col gap-2">
                <button
                    onClick={handleCenterMap}
                    className={cn(
                        "w-8 h-8 flex items-center justify-center rounded-sm shadow-md transition-colors",
                        components.button.secondary
                    )}
                    title={t('Re-Center')}
                >
                    <Target size={18} />
                </button>
                
                <button
                    onClick={handleToggleTooltips}
                    className={cn(
                        "w-8 h-8 flex items-center justify-center rounded-sm shadow-md transition-colors",
                        components.button.secondary
                    )}
                    title={t(showTooltips ? 'Hide tooltips' : 'Show tooltips')}
                >
                    {showTooltips ? (
                        <Eye size={14} />
                    ) : (
                        <EyeOff size={14} />
                    )}
                </button>

                {isDriver && (
                    <button
                        onClick={onForceRefresh}
                        className={cn(
                            "w-8 h-8 flex items-center justify-center rounded-sm shadow-md transition-colors",
                            components.button.secondary
                        )}
                        title={t('Refresh ETAs')}
                    >
                        <RefreshCw size={14} />
                    </button>
                )}
            </div>
        </div>
    );
});
MapControls.displayName = 'MapControls';

export default MapControls;
